import get from 'transmute/get';
export const typingStates = get('typingStates');